import React, { useState } from 'react';
import { Building2, Wallet, Link2, CalendarDays } from 'lucide-react';
import DadosEstabelecimentoTab from './DadosEstabelecimentoTab';
import FormasPagamentoTab from './FormasPagamentoTab';
import PaginaPublicaTab from './PaginaPublicaTab';
import FluxoAgendaTab from './FluxoAgendaTab';

const ABAS = [
  { id: 'dados', label: 'Dados do Estabelecimento', icon: <Building2 size={16} /> },
  { id: 'formasPagamento', label: 'Formas de Pagamento', icon: <Wallet size={16} /> },
  { id: 'paginaPublica', label: 'Página Pública', icon: <Link2 size={16} /> },
  { id: 'fluxo', label: 'Fluxo da Agenda', icon: <CalendarDays size={16} /> },
];

const MinhaAgendaPage = ({ temAcesso }) => {
  const [activeTab, setActiveTab] = useState('dados');

  return (
    <div className="w-full max-w-[950px] mx-auto p-4 box-border overflow-x-hidden font-sans text-left">
      <div className="bg-[#F8F7FF] p-1.5 rounded-[20px] flex flex-wrap gap-1.5 mb-8 w-full box-border border border-purple-50">
        {ABAS.map(aba => (
          <button
            key={aba.id}
            className={`flex-1 min-w-[120px] justify-center py-3 px-4 border-none rounded-2xl cursor-pointer text-[10px] font-black uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${activeTab === aba.id ? 'bg-white text-[#6D28D9] shadow-sm' : 'bg-transparent text-slate-400'}`}
            onClick={() => setActiveTab(aba.id)}
          >
            {aba.icon} {aba.label}
          </button>
        ))}
      </div>

      {activeTab === 'dados' && <DadosEstabelecimentoTab temAcesso={temAcesso} />}
      {activeTab === 'formasPagamento' && <FormasPagamentoTab />}
      {activeTab === 'paginaPublica' && <PaginaPublicaTab temAcesso={temAcesso} />}
      {activeTab === 'fluxo' && <FluxoAgendaTab />}
    </div>
  );
};

export default MinhaAgendaPage;
